/* eslint-disable @next/next/no-img-element */
import InstantArticle from "views/articles/InstantArticle"
import BestInstagramApps from "views/articles/BestInstagramApps"
import Link from "next/link"
import { AppInterface } from "types/types"
import AppsListItem from "components/AppsListItem"
import AppsList from "components/AppsList"

const AddAppollowToYourHomeScreenEN = ({
  apps,
  otherApps,
}: {
  apps: AppInterface[]
  otherApps: AppInterface[]
}) => {
  const article = BestInstagramApps["en"]
  return (
    <InstantArticle {...article}>
      <div style={{ textAlign: "justify" }}>
        <p>
          Instagram is an excellent platform for businesses to grow their brand.
          You can use it for photos, videos, and even live videos. However, if
          you want to get the most out of Instagram,&nbsp;In this blog post,
          we&nbsp;ve compiled a list of the best iOS apps and tools for
          Instagram that we&nbsp;ve come across so far.
        </p>
        <h2>VSCO </h2>
        <p>
          VSCO is a photo editing app that has many filters and effects. The app
          is free to download, but you can also pay for some of the premium
          features. You can set up your account in minutes, which includes
          adding all the social media accounts you want to use with VSCO.
        </p>
        <p>
          VSCO&nbsp;s interface is simple enough for anyone who has used
          Instagram before, but it still offers plenty of options for those
          looking to get creative with their photos on social media platforms
          like Facebook or Twitter as well!
        </p>
        <p>
          You&nbsp;ll find a variety of different filters built into this
          app—you&nbsp;ll find everything from vintage film tones (perfect if
          you&nbsp;re trying to achieve that retro feel) through bright colors
          such as reds/blues/greens; there are even some watercolor effects
          included within this application so that users can create something
          truly unique when photographing landscapes inside their homes or world
          travel destinations abroad!
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 588013838)} />
        </div>
        <h2>Layout from Instagram</h2>
        <p>
          Layout from Instagram is a free tool that allows you to create
          professional-looking layouts for your Instagram profile picture, cover
          photo and story. You can use it to combine multiple photos into one
          collage or create a mosaic of images in different sizes.
        </p>
        <p>
          Layout from Instagram is available on both iOS and Android smartphones
          as well as computers running macOS or Windows 10.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 967351793)} />
        </div>
        <h2>Canva</h2>
        <p>
          Canva is a free and easy-to-use online design tool that can help you
          create graphics for your Instagram profile. You can use Canva to make
          collages, memes, logos and more.
        </p>
        <p>
          Canva has hundreds of templates to choose from so you can easily find
          one that fits the theme of your post or photo. You can also upload
          photos directly from your phone or computer if you don&nbsp;t have a
          template in mind yet!
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 897446215)} />
        </div>
        <h2>Unfold</h2>
        <p>
          If you&nbsp;re into creating Instagram stories, Unfold is a must-have
          app. It has a wide range of templates and design elements that you can
          use to create professional-looking stories in just a few minutes.
        </p>
        <div className="card card-style pt-3 px-3" dir="ltr">
          <AppsListItem {...apps.find((item) => item.trackId === 1247275033)} />
        </div>
        <h2>Other</h2>
        <p>
          Also, learn about what users prefer, here are some of the applications
          that our users use with Instagram
        </p>
        <div dir="ltr">
          <AppsList apps={otherApps} title="" />
        </div>
        <div className="card mt-4">
          <div className="card-body">
            <div className="text-center">
              <i className="fa fa-star color-yellow-dark fa-2x mb-3 "></i>
            </div>
            <p className="color-white">
              Do you have any favorite apps or tools that you use to get the
              most out of the platform? You can submit your favorite apps
              through Appollow&apos;s{" "}
              <Link href="/submit">
                <span className="text-white text-decoration-underline">
                  submit page
                </span>
              </Link>
            </p>
          </div>
          <div className="card-overlay bg-highlight opacity-95" />
          <div className="card-overlay dark-mode-tint" />
        </div>
      </div>
    </InstantArticle>
  )
}

export default AddAppollowToYourHomeScreenEN
